'use client';

import { cva } from 'class-variance-authority';
import { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils/classnameVariants';
import { textToAnchorId } from '../../lib/utils/textToAchorId';
import { ActionListItem, ActionListItemContent } from '../atoms/ActionListItem';

export const actionListVariant = cva('grid gap-4 pt-4 lg:grid-flow-col lg:grid-cols-2 lg:pt-6', {
  variants: {
    gridRows: {
      2: 'lg:grid-rows-2',
      3: 'lg:grid-rows-3',
      4: 'lg:grid-rows-4',
    },
  },
  defaultVariants: {
    gridRows: 2,
  },
});

export interface ActionListProps extends InputHTMLAttributes<HTMLDivElement> {
  actions: ActionListItemContent[] | undefined;
  header: string;
}

const ActionList = forwardRef<HTMLDivElement, ActionListProps>(({ className, header, actions, ...props }, ref) => {
  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <div {...props} ref={ref} className={cn('relative flex flex-col', className)}>
      <div className="flex w-full items-center justify-between">
        <p
          id={textToAnchorId(header)}
          className="line-clamp-6 w-full text-ellipsis break-words font-graphik text-xl font-medium leading-graphik text-black-900 sm:text-lg"
        >
          {header}
        </p>
      </div>

      <div className={actionListVariant({ gridRows: Math.min(Math.round(actions.length / 2), 4) as 2 | 3 | 4 })}>
        {actions.map((action, index) => (
          <ActionListItem {...action} key={index} />
        ))}
      </div>
    </div>
  );
});
ActionList.displayName = 'ActionList';

export { ActionList };
